import React from 'react';
import { Forms, Loading, Paging, StringHelpers, SystemText } from 'e4shared';
import { addDays, e4Format, e4Formats } from 'helpers/dates';
import { useSelector } from 'react-redux';
import { apiGet } from 'services';

export const Gong = ({ assets, allowMultiple, onAdd }) => {
    const now = new Date();
    const [results, setResults] = React.useState([]);
    const [items, setItems] = React.useState(assets);
    const [search, setSearch] = React.useState(null);
    const [from, setFrom] = React.useState(addDays(now, -7));
    const [to, setTo] = React.useState(now);
    const [page, setPage] = React.useState(1);
    const [error, setError] = React.useState('');
    const [loading, setLoading] = React.useState(false);
    const [doneSearch, setDoneSearch] = React.useState(false);
    const guid = useSelector(state => (state.user.user ? state.user.user.guid : ''));

    const pageSize = 5;

    const st = (path, ...rest) => SystemText(`Admin/Forms/FilePicker/Gong/${path}`, ...rest);

    const runSearch = () => {
        setLoading(true);
        setError('');
        apiGet(
            `integrations/gong?search=${search}&from=${e4Format(from, e4Formats.urlSafe)}&to=${e4Format(
                to,
                e4Formats.urlSafe
            )}`,
            guid,
            response => {
                setPage(1);
                setDoneSearch(true);
                setLoading(false);
                setResults(
                    response.map(call => {
                        return {
                            name: call.title,
                            description: `${call.fullName} - ${call.system}`,
                            duration: call.duration,
                            date: call.started,
                            id: call.id,
                        };
                    })
                );
            },
            err => {
                console.error(err);
                setLoading(false);
            }
        );
    };

    React.useEffect(() => {
        items && onAdd(items, 'gong');
    }, [items]);

    const addItem = add => {
        if (allowMultiple) {
            if (!items.some(i => i.internal_Id === add.id)) {
                setItems(items.concat([{ ...add, url: add.url, internal_Id: add.id }]));
            }
        } else {
            setItems([{ ...add, url: add.url, internal_Id: add.id }]);
        }
    };

    const removeItem = remove => {
        setItems(items.filter(i => i.internal_Id !== remove.internal_Id));
    };

    if (loading) return <Loading />;

    const start = (page - 1) * pageSize;
    const end = start + pageSize - 1;

    const Card = ({ result }) => {
        return (
            <div key={`${result.id}`} className="flex mb10 pitch-card pointer" onClick={() => addItem(result)}>
                <div className="">
                    <img src="/dist/img/gong-icon.png" alt="" loading="lazy" />
                </div>
                <div className="flex-grow ml10">
                    <label>{result.name}</label>
                    <div className="text-sm">
                        {e4Format(result.date)} - {st('Duration')}: {StringHelpers.displaySeconds(result.duration)}
                    </div>
                    <div className="text-sm">{result.description}</div>
                </div>
            </div>
        );
    };

    return (
        <div className="">
            <div>
                <Forms.Text
                    id="filter-search"
                    label={st('Search/Label')}
                    help={st('Search/Help')}
                    placeholder={st('Search/Placeholder')}
                    value={search}
                    error={error}
                    onChange={x => setSearch(x)}
                    onSubmit={runSearch}
                    icon="fa-search"
                />
                <div className="row">
                    <div className="col-md-6">
                        <Forms.Date
                            id="filter-from"
                            label={st('Search/From')}
                            value={from}
                            error={error}
                            onChange={x => setFrom(x)}
                            onSubmit={runSearch}
                        />
                    </div>
                    <div className="col-md-6">
                        <Forms.Date
                            id="filter-to"
                            label={st('Search/To')}
                            value={to}
                            error={error}
                            onChange={x => setTo(x)}
                            onSubmit={runSearch}
                        />
                    </div>
                </div>
            </div>
            <div className="mb10">
                <button id="search-button" className="btn btn-primary" onClick={runSearch} disabled={!search}>
                    {st('Buttons/Search')}
                </button>
            </div>
            {results.length === 0 && doneSearch && <div>{st('NoResults')}</div>}
            {results.length > 0 && (
                <div>
                    <div>
                        <label>{st('Results')}</label>
                        <span className="text-sm ml10">{st('Select')}</span>
                    </div>
                    <div className="list">
                        {results.map((t, i) => (i < start || i > end ? null : <Card key={`card-${i}`} result={t} />))}
                    </div>
                    {results.length > 0 && (
                        <Paging
                            pageSize={pageSize}
                            recordCount={results.length}
                            page={page}
                            goToPage={page => setPage(page)}
                        />
                    )}
                </div>
            )}
            {items.length > 0 && (
                <div className="mt20">
                    <label>{st('Selected')}</label>
                    {items
                        .sort((a, b) => (a.name > b.name ? 1 : -1))
                        .map((u, i) => {
                            return (
                                <div key={`file-${i}`} className="mb5 flex flex-center">
                                    <i className={`fa fa-microphone mr5`} />
                                    <span className="ellipsis500 flex-grow">{u.name}</span>
                                    <i
                                        className="ml5 text-danger fa fa-trash pointer text-right"
                                        title={st('Remove', u.name)}
                                        onClick={() => removeItem(u)}
                                        data-testid="remove-video"
                                    />
                                </div>
                            );
                        })}
                </div>
            )}
        </div>
    );
};

export default Gong;
